import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ChartLineUp } from '@phosphor-icons/react';
import WorkforceUserPage from './pages/WorkforceUserPage';

function WorkforceLayout() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="app-module-shell">
      <div className="tk-module-header">
        <div className="tk-module-brand">
          <div className="tk-module-mark" aria-hidden="true">
            <ChartLineUp size={20} weight="fill" />
          </div>
          <div>
            <h1 className="tk-module-title">Work Intelligence</h1>
            <p className="tk-module-subtitle">Live availability and user work analytics</p>
          </div>
        </div>
        <button type="button" className="tk-btn tk-btn-secondary" onClick={() => setRefreshKey((k) => k + 1)}>
          Refresh
        </button>
      </div>

      <div className="tk-page">
        <Routes>
          <Route index element={<WorkforceUserPage refreshKey={refreshKey} />} />
          <Route path="users" element={<Navigate to="/dashboard/workforce" replace />} />
          <Route path="assistant" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default WorkforceLayout;
